function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "target-completed",
  transform: "translate(-205.807 -88.2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_106",
  "data-name": "Subtraction 106",
  d: "M20.8,41.6A20.8,20.8,0,0,1,6.089,6.089,20.672,20.672,0,0,1,20.8,0c.64,0,1.285.029,1.918.087a16.449,16.449,0,0,0-2.632,2.525A18.2,18.2,0,0,0,20.8,39,18.332,18.332,0,0,0,37.188,28.717,16.261,16.261,0,0,0,40.569,27.3,20.836,20.836,0,0,1,20.8,41.6Zm0-6.759A14.058,14.058,0,0,1,6.759,20.8a13.885,13.885,0,0,1,3.032-8.706A14.143,14.143,0,0,1,17.4,7.174a16.407,16.407,0,0,0-.719,2.4A11.961,11.961,0,0,0,20.8,32.76a11.864,11.864,0,0,0,8.641-3.707,16.725,16.725,0,0,0,2.491.3A13.954,13.954,0,0,1,20.8,34.841Zm0-6.643A7.4,7.4,0,0,1,16.411,14.85a16.309,16.309,0,0,0,.442,2.376,5.318,5.318,0,0,0,3.947,8.88h0v.01l.013,0a5.27,5.27,0,0,0,1.684-.275A16.228,16.228,0,0,0,24.505,27.2,7.374,7.374,0,0,1,20.8,28.2Z",
  transform: "translate(205.807 88.199)",
  fill: "#a9adb9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_102",
  "data-name": "Subtraction 102",
  d: "M13.051,26.1A13.05,13.05,0,1,1,26.1,13.051,13.066,13.066,0,0,1,13.051,26.1Zm-5.3-13.928h0L5.976,13.949l5.04,5.04L21.1,8.91,19.32,7.133l-8.3,8.3L7.752,12.173Z",
  transform: "translate(226.091 88.199)",
  fill: "#18c23a"
}));

function SvgTargetCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.385,
    height: 41.6,
    viewBox: "0 0 46.385 41.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetCompleted);
export default __webpack_public_path__ + "static/media/target-completed.c41693bb.svg";
export { ForwardRef as ReactComponent };